import React from "react";
export * from "./provider";

export const GenericModalContext = React.createContext({});
